import { Button } from 'primereact/button';
import { useAtom } from 'jotai';
import { siteThemeMode } from '~/atoms/userPreferencesAtoms';

export const ThemeToggle = () => {
  const [mode, setMode] = useAtom(siteThemeMode);
  const isDarkMode = mode === 'dark';
  const nextMode = isDarkMode ? 'light' : 'dark';

  return (
    <Button
      type="button"
      text
      rounded
      severity="secondary"
      icon={isDarkMode ? 'pi pi-sun' : 'pi pi-moon'}
      aria-label={`Switch to ${nextMode} mode`}
      onClick={() => setMode(nextMode)}
      tooltip={`Switch to ${nextMode} mode`}
      tooltipOptions={{ position: 'bottom' }}
      style={{
        width: '2.5rem',
        height: '2.5rem',
        padding: 0,
        fontSize: '1rem',
      }}
    />
  );
};
